
export const getEditableImages = ({items: productModelItems, onlyVisibleOrderImages}) => productModelItems
    // skip items that do not have valid image assets
    .filter(item => (
        item.type === "PlaceholderItem" && // check image areas only
        item._name && // use only those with a name - some duplicate records exist without a name
        !item._locked && // use only user-editable items
        (
            // used by linkId behavior and import order photo. Need to keep linked image functionality.
            !onlyVisibleOrderImages ||
            (
                item._visible && // use only visible items
                item.allowedTabs?.some(allowedTab => ["Image Gallery", "Property Photos"].includes(allowedTab))
            )
        )
    ) )
    // set relevant image data to be returned - feel free to add attributes as needed
    .map(item => ({
        id: item.id,
        name: item._name,
        surfaceName: item._parentContainer.parentComponent._name,
        left: Math.round(item._sourceRectangle._left + item._transform._translateX),
        top: Math.round(item._sourceRectangle._top + item._transform._translateY),
        width: Math.round(item._sourceRectangle._width),
        height: Math.round(item._sourceRectangle._height),
        allowedTabs: item.allowedTabs,
        linkId: item.linkId || null,

        // add image properties if an image is already selected for the area
        ...item._content?._source && {
            image: {
                ccStorageId: item._content._source._storageId,
                httpPath: '',
                width: item._content._source._width,
                height: item._content._source._height
            },
        },

    }));
